import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import { ColorButton } from "../../components/common/CustomButton.js";
import { DialogTitle } from "../../components/common/dialog/DialogTitle";
import { DialogContent } from "../../components/common/dialog/MuiDialogContent";
import Carousel from "react-material-ui-carousel";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import CardActionArea from "@material-ui/core/CardActionArea";
import * as Constants from "../../consts/Constants.js";
import * as ScreenText from "../../consts/ScreenText.js";
import { formatDateDDMMYYYYHHMM } from "../../utils/DateUtils";

import Style from "../../styles/js/StyleReports.js";

export default function ReportExpanded({
  open,
  setOpen,
  reportSelected,
  updateState,
  disabledButtons,
}) {
  const style = Style();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        className={style.dialog}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Reporte de {reportSelected.reportTypeName}
        </DialogTitle>
        {reportSelected.binsId !== undefined &&
        reportSelected.binsId.length > 0 ? (
          <DialogContent dividers>
            <Carousel autoPlay={false}>
              {reportSelected.binsId.map((id) => (
                <CardActionArea
                  component="a"
                  href={Constants.FINAL_URL_BINS + id}
                  className={style.cardActionArea}
                >
                  <CardMedia
                    component="img"
                    image={Constants.FINAL_URL_BINS + id}
                    className={style.cardMedia}
                    title="Click para ver la imagen en una nueva ventana"
                  ></CardMedia>
                </CardActionArea>
              ))}
            </Carousel>
          </DialogContent>
        ) : null}
        <CardContent>
          <Typography className={style.textExpanded}>
            {reportSelected.description}
          </Typography>
          <Typography className={style.textExpanded}>
            Usuario denunciante: {reportSelected.userName}
          </Typography>
          <Typography className={style.textExpanded}>
            Fecha: {formatDateDDMMYYYYHHMM(reportSelected.creationTime)}
          </Typography>
          <Typography className={style.textExpanded}>
            Estado: {ScreenText.REPORT_NAME_STATE[reportSelected.state]}
          </Typography>
          <div className={style.divButtons}>
            {reportSelected.state !== Constants.REPORT_SERVICE_FINISH &&
            reportSelected.state !== Constants.REPORT_SERVICE_DISMISS ? (
              <ColorButton
                className={style.actionButton}
                variant="contained"
                disabled={disabledButtons}
                onClick={() =>
                  updateState(reportSelected, reportSelected.state + 1)
                }
              >
                {ScreenText.REPORT_EXPANDED_BUTTON[reportSelected.state]}
              </ColorButton>
            ) : null}
            {reportSelected.state === Constants.REPORT_SERVICE_ATTENDING ? (
              <ColorButton
                className={style.actionButton}
                variant="contained"
                disabled={disabledButtons}
                onClick={() =>
                  updateState(reportSelected, Constants.REPORT_SERVICE_DISMISS)
                }
              >
                {ScreenText.REPORT_DISMISS_BUTTON}
              </ColorButton>
            ) : null}
          </div>
        </CardContent>
      </Dialog>
    </div>
  );
}
